import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class FoodsService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('foods/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('foods/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('foods/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('foods/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('foods/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('foods/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('foods/delete', val_id);
  }
}
